import AutorizacionesCondiciones from './autorizaciones-condiciones.vue';
import Error403 from './../403.vue';
import RoutesUtils from '../../js/RoutesUtils.js';
import { conUsuarioActualizado } from '../../js/barreraUsuarioActualizado.js';
import { ROLES_AJUSTES_AUTORIZACIONES, RUTA_AJUSTES_AUTORIZACIONES } from './permisos.js';

// #905 · Ajustes › Autorizaciones de condiciones de facturación. Mismo acceso que el mapa de
// aprobación de vacaciones, que es el patrón que pidió Dirección: la entrada de menú bajo Ajustes
// decide quién la ve y la API da 403 a quien no sea ADMIN o DIRECTOR. Entra por la barrera de
// usuario actualizado por lo mismo que aquel (ver `barreraUsuarioActualizado.js`).
const routes = [
    {
        path: RUTA_AJUSTES_AUTORIZACIONES,
        beforeEnter: RoutesUtils.checkAuthPage,
        async: conUsuarioActualizado(function(routeTo) {
            if (!RoutesUtils.tieneAcceso(routeTo.path, ROLES_AJUSTES_AUTORIZACIONES)) {
                return { component: Error403 };
            }
            return { component: AutorizacionesCondiciones };
        }),
        keepAlive: true
    }
];
export default routes;
